// extracted by mini-css-extract-plugin
export default {"restrictedMessage":"vdMT8RLOB3Eg_5xDdWkF","placeHolderShimmer":"n5IpSMXJhLnl7IvRaSPe"};